import { CheckboxGroup } from '@tablesready/checkbox-group';

export const SettingsToCopy: CheckboxGroup[] = [
  {
    name: 'Auto-remove waiting parties from your list after',
    value: 'autoRemove',
  },
  {
    name: 'Default party size',
    value: 'default_size',
  },
  {
    name: 'Default wait time (mins)',
    value: 'default_quoted_time',
  },
  {
    name: 'Sort parties by',
    value: 'waitListSortBy',
  },
  {
    name: 'Display options',
    value: 'displayOptions',
  },
  {
    name: 'Notifications',
    value: 'messages',
  },
  {
    name: 'Wait fields to display',
    value: 'waitFields',
  },
  {
    name: 'Public Options',
    value: 'publicWaitlist',
  },
  {
    name: 'Resources',
    value: 'resourceSettings',
  },
  {
    name: 'Reservation Options',
    value: 'bookingOptions',
  },
  {
    name: 'Services',
    value: 'serviceSettings',
  },
  {
    name: 'Alerts',
    value: 'alertsSettings',
  },
  {
    name: 'Note options',
    value: 'noteOptions',
  },
  {
    name: 'Automations',
    value: 'automations',
  },
  {
    name: 'Schedules, services, resources',
    value: 'entities',
  },
  {
    name: 'Custom fields',
    value: 'partyFields',
  },
];
